import getCharts from '../getCharts'
import { FacilityLogin } from '../../constants/api.config'

export default async function FacilityLoginFn(mode, Id="",Name="",Link="",Uname="",Password="",Type="") {
  try {
    const jsonData = {Id,Name,Link,Uname,Password,Type}
    const payload = {mode,jsonData:JSON.stringify(jsonData)}
    const res = await getCharts(FacilityLogin, payload)
    return res.data
  } catch (error) {
    return error
  }
}
